var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row items-center float-left" },
      [
        _c("q-icon", {
          class: ["circle", _vm.up ? "bg-positive" : "bg-red-5"],
          attrs: { name: _vm.icon, color: "white" }
        }),
        _c(
          "span",
          { class: ["on-right", _vm.up ? "text-positive" : "text-red-5"] },
          [_vm._v(_vm._s(_vm.text))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }